export class AdbAndroidIdentifier {
  constructor(public PhysicalAddress: string, public IpAddress: string) {}
}
